import { useState } from "react";

/**
 * LoginPage
 * Props:
 *   onSubmit({ email, password })
 *   onSocialLogin(provider)
 *   onForgotPassword()
 *   onGoToSignup()
 */
export default function LoginPage({ onSubmit, onSocialLogin, onForgotPassword, onGoToSignup }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  function handleSubmit(e) {
    e.preventDefault();
    onSubmit?.({ email, password });
  }

  return (
    <div style={{ maxWidth: 380, margin: "0 auto", background: "var(--surface-1)", borderRadius: "var(--radius-lg)", padding: "2rem" }}>
      <p style={{ fontSize: "var(--text-xl)", fontWeight: 500, margin: "0 0 20px" }}>Log in</p>

      <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
        <button type="button" className="ical-btn" style={{ flex: 1 }} onClick={() => onSocialLogin?.("google")}>Google</button>
        <button type="button" className="ical-btn" style={{ flex: 1 }} onClick={() => onSocialLogin?.("github")}>GitHub</button>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 10, margin: "16px 0" }}>
        <div style={{ flex: 1, height: 1, background: "var(--border)" }} />
        <span style={{ fontSize: "var(--text-xs)", color: "var(--text-muted)" }}>or</span>
        <div style={{ flex: 1, height: 1, background: "var(--border)" }} />
      </div>

      <form onSubmit={handleSubmit}>
        <label style={{ fontSize: "var(--text-sm)", color: "var(--text-secondary)", display: "block", marginBottom: 4 }}>Email</label>
        <input
          className="ical-input"
          type="email"
          required
          placeholder="name@company.com"
          style={{ width: "100%", marginBottom: 12 }}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
          <label style={{ fontSize: "var(--text-sm)", color: "var(--text-secondary)" }}>Password</label>
          <button type="button" onClick={onForgotPassword} style={{ fontSize: "var(--text-xs)", color: "var(--text-accent)", background: "none", border: "none", cursor: "pointer", padding: 0 }}>
            Forgot?
          </button>
        </div>
        <input
          className="ical-input"
          type="password"
          required
          placeholder="Password"
          style={{ width: "100%", marginBottom: 20 }}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button type="submit" className="ical-btn ical-btn-primary" style={{ width: "100%" }}>Log in</button>
      </form>

      <p style={{ fontSize: "var(--text-xs)", color: "var(--text-muted)", textAlign: "center", margin: "14px 0 0" }}>
        No account?{" "}
        <button type="button" onClick={onGoToSignup} style={{ color: "var(--text-accent)", background: "none", border: "none", cursor: "pointer", padding: 0, fontSize: "inherit" }}>
          Sign up
        </button>
      </p>
    </div>
  );
}
